import { render } from "./Access_Resend_Payment_Checkout.vue?vue&type=template&id=71c71216&scoped=true"
import script from "./Access_Resend_Payment_Checkout.vue?vue&type=script&lang=js"
export * from "./Access_Resend_Payment_Checkout.vue?vue&type=script&lang=js"

import "./Access_Resend_Payment_Checkout.vue?vue&type=style&index=0&id=71c71216&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c71216"]])

export default __exports__